/**
 * Static authentication configuration.
 *
 * This panel serves a single facade (qr-phone.com); the identity realm is a
 * constant of the product. The only per-environment value is the OIDC client
 * id (production vs the dev host), which comes from build configuration.
 * Names are generic on purpose; no identity-provider product name is exposed.
 */

/** Human label shown in the app shell and the tab title. */
export const APP_NAME = 'QR Phone';

/** Identity service base URL. */
export const AUTH_AUTHORITY = 'https://id.qr-phone.com';

/** Identity realm. */
export const AUTH_REALM = 'qr-phone';

/** OIDC client id for this browser app (per environment). */
export const AUTH_CLIENT_ID: string = import.meta.env.VITE_AUTH_CLIENT_ID || 'qr-phone-admin';
